export default __webpack_public_path__ + "static/media/Ordeño2.cea5a9d0.jpeg";